import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { getNotificationsFulfilled } from '../../api/notification.api';
import type { NotificationPaginatedResponse } from '../types/notification';
import type { NotificationSchema } from '../types/notification.schema';

// Initial state with unread count set to 0
const initialState: NotificationSchema = {
    unreadCount: 0,
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(
            getNotificationsFulfilled,
            (state, action: PayloadAction<NotificationPaginatedResponse>) => {
                // Calculate unread count from notifications
                state.unreadCount = action.payload.results.filter(
                    (notification) => !notification.read,
                ).length;
            },
        );
    },
});

export const { actions: notificationActions, reducer: notificationReducer } =
    notificationSlice;
